import { GetVideoRealTimeSessionResult } from "@/request/modules/gen_api_4194";
import { createSlice } from "@reduxjs/toolkit";
import { MqttClient } from "mqtt";

interface MqttReducer {
    connected?: boolean;
    client?: MqttClient;
    videoReals?: GetVideoRealTimeSessionResult[];
}

const initialState: MqttReducer = {
    connected: false,
    videoReals: [],
};

const user = createSlice({
    name: "mqtt",
    initialState,
    reducers: {
        setClient: (state, { payload }) => {
            state.client = payload;
        },
        setConnected: (state, { payload }) => {
            state.connected = payload;
        },
        setVideoReals: (state, { payload }) => {
            state.videoReals = payload;
        },
    },
});

export default user.reducer;